import {getLocalStorageValue} from "../../../utils/storeUtil";

export default {
	name: 'Gameplay',
	state: {
		seasonID: null,
		gameModeID: null,
		sportID: null,
		newTeamFormData: null,
		showDebugOptions: null,
		seasonCustomLeagueID: null,
	},
	mutations: {
		initiateGameplay: (state, value) => {
			const keysToRetrieve = [
				{key: 'seasonID', type: 'integer'},
				{key: 'gameModeID', type: 'integer'},
				{key: 'sportID', type: 'integer'},
				{key: 'newTeamFormData', type: 'json'},
				{key: 'showDebugOptions', type: 'boolean'},
				{key: 'seasonCustomLeagueID', type: 'integer'},
			];

			keysToRetrieve.forEach(({key, type}) => {
				const {hasValue, returnValue} = getLocalStorageValue(key, type);
				if (hasValue) {
					if (type === 'boolean') {
						// Default to false if no valid value exists in localStorage
						state[key] = returnValue === 'true' ? true : false;
					  } else {
						state[key] = returnValue;
					  }
				}
			});
		},
		setSeasonID: (state, value) => {
			state.seasonID = value;
			localStorage.setItem('seasonID', state.seasonID);
		},
		setGameModeID: (state, value) => {
			state.gameModeID = value;
			localStorage.setItem('gameModeID', state.gameModeID);
		},
		setSportID: (state, value) => {
			state.sportID = value;
			localStorage.setItem('sportID', state.sportID);
		},
		setNewTeamFormData: (state, value) => {
			state.newTeamFormData = value;
			if (value == null) {
				localStorage.removeItem('newTeamFormData')
			} else {
				localStorage.setItem('newTeamFormData', JSON.stringify(value))
			}
		},
		setShowDebugOptions: (state, value) => {
			state.showDebugOptions = value;
			localStorage.setItem('showDebugOptions', state.showDebugOptions);
		},
		setSeasonCustomLeagueID: (state, value) => {
			if (value == null) {
				state.seasonCustomLeagueID = null;
				localStorage.removeItem('seasonCustomLeagueID');
			} else {
				state.seasonCustomLeagueID = value;
				localStorage.setItem('seasonCustomLeagueID', state.seasonCustomLeagueID);
			}
		},
	},
	getters: {
		seasonID(state) {
			return state.seasonID;
		},
		gameModeID(state) {
			return state.gameModeID;
		},
		sportID(state) {
			return state.sportID;
		},
		newTeamFormData(state) {
			return state.newTeamFormData;
		},
		showDebugOptions(state) {
			return state.showDebugOptions;
		},
		seasonCustomLeagueID(state) {
			return state.seasonCustomLeagueID;
		},
	},
}
